import request from '@/utils/serverApp'

export function orderBack(columnId, orderPhone) {
    return request({
        url: `/color/unsubscribe?columnId=${columnId}&phone=${orderPhone}`,
        method: 'get'
    })
}

export function getList(data) {
    return request({
        url: '/column/listByPage',
        method: 'post',
        data
    })
}

export function checkBuy(columnId, orderPhone) {
    return request({
        url: `/color/checkBuy?columnId=${columnId}&phone=${orderPhone}`,
        method: 'get'
    })
}

export function getNewsDetail(data) {
    return request({
        url: '/color/getNewsDetail',
        method: 'post',
        data
    })
}